export default "__VITE_ASSET__ConsBiUq__"